<template>
    <div class="page">
        <public-head title="全部院校"></public-head>
       <!-- 跳转到搜索页面 -->
<div class="search" @click="$router.push('/fenlei/search/?go='+1)">
    <input class="search-content" placeholder="请输入院校名称" disabled="disabled"/>
    <img class="search-icon" src="https://new.schoolpi.net/attach/small_program/search/search_icon.jpg" />
</div>

    <van-list class="school-list" v-if="schoolLists.length>0&&id==14234 " finished-text="没有更多了"
            @load="onLoad">
           <div>
        <div v-for="(item,index) in schoolLists" :key="index" :finished="finished">
            <div class="school-item" @click="goHostDetail(item.sid)">
                <img class="school-logo" :src="item.logo" />
                <div class="school-info">
                    <div class="school-name">{{item.name}}</div>
                    <div class="flex">
                        <div class="info-item">{{item.arr.one}}</div>
                        <div class="info-item">{{item.arr.two}}</div>
                    </div>
                    <div class="flex">
                         <div class="info-item">{{item.arr.threee}}</div>
                        <div class="info-item">{{item.arr.four}}</div>
                    </div>
                </div>
                <div class="school-hot">人气:{{item.mood}}</div>
            </div>
         </div>
        </div> 
    </van-list>
    <van-list class="school-list" v-if="schoolLists.length>0&&id==10808 " finished-text="没有更多了"
            @load="onLoad">
        <div v-for="(item,index) in schoolLists" :key="index">
            <div class="school-item" @click="goHostDetail(item.sid)">
                <img class="school-logo" :src="item.logo" />
                <div class="school-info">
                    <div class="school-name">{{item.name}}</div>
                    <div class="flex">
                        <div class="befor">提前</div>
                        <div class="info-item2">{{item.arr.duikou_one}}</div>
                         <div class="counterpart">对口</div>
                         <div class="info-item2">{{item.arr.tiqian_one}}</div>
                </div>
                </div>
                <div class="school-hot">人气:{{item.mood}}</div>
            </div>
        </div>
    </van-list>
    <div v-else class="_noPost">
       <image src="https://new.schoolpi.net/attach/small_program/index/no-data.png" class="no-data"></image>
    </div>

    </div>
</template>

<script>
import PublicHead from "../../../components/publicHead";
import { httpPost } from "../../../axios/index";
export default {
    data() {
        return {
            schoolLists: [],
            page: 1,
            num: 10,
            arrs: [],
            id:0,
            finished:false
        };
    },
    created() {},
    methods: {
        // 上拉加载
        onLoad() {
            this.page = this.page + 1;
            httpPost("/classifie/school_list", {
                province: this.$store.state.areaInfo.pid,
                page: this.page
            }).then(res => {
                if (res.code === 1) {
                   this.schoolLists = [... this.schoolLists, ...res.list];
                   this.$toast.loading({
                    message: "加载中...",
                    forbidClick: true
                });
                }else{
                    this.finished=true;	
                }
                
            });
        },
        // 进入详情
        goHostDetail(e){
           this.$router.push({
               path:"/fenlei/HostDetail",
               query:{
                   sid:e
               }
           })
        },
        // 获取全部院校数据
        fetchallSchool() {
            httpPost("/classifie/school_list", {
                province: this.$store.state.areaInfo.pid,
                page: this.page
            }).then(res => {
               
                if (res.code === 1) {
                    this.schoolLists = res.list;
                }
            });
        }
    },
    mounted() {
         this.id=this.$store.state.areaInfo.pid;
        this.fetchallSchool();
    },
    components: {
        PublicHead
    }
};
</script>

<style scoped>
.page {
    background: #f2f2f2;
}
.search {
    background: #22d8d9;
    padding: 0.625rem 0;
    position: relative;
    margin-top: 46px;
}
.search-content {
    height:1.875rem;
    margin: 0 0.9375rem;
    background: #fff;
    border-radius: 0.9375rem;
    padding-left: 2.0625rem;
    font-size: 0.8125rem;
    width: 88%;
    border: 0;
    outline: none
}
.search-icon {
    width: 0.9375rem;
    height: 0.9375rem;
    position: absolute;
    left: 1.5625rem;
    top: 0;
    bottom: 0;
    margin: auto 0;
    /* border: 2rpx solid red; */
}
.school-item:first-child {
    margin-top: 0rpx;
}
.school-item {
    display: flex;
    margin-top: 0.625rem;
    background: #fff;
    position: relative;
}
.school-logo {
    width: 3.75rem;
    height: 3.75rem;
    margin: 0.625rem 0.9375rem;
    border-radius: 1.875rem;
}
.school-name {
    font-size: 0.9375rem;
    margin: 0.625rem 0 0.375rem 0;
    font-weight: bold;
}
.flex {
    margin-top: 5px;
    display: flex;
}
.info-item {
    width: 8.4375rem;
    font-size: 0.75rem;
    color: #a9a9a9;
    margin-bottom: 10rpx;
}
.school-hot {
    position: absolute;
    top: 0.8125rem;
    right: 0.9375rem;
    color: #ffbb29;
    font-size: 0.75rem;
}
._noPost {
    text-align: center;
    position: relative;
}
.no-data {
    width: 6.25rem;
    height: 7.1875rem;
    position: absolute;
    top: 10.9375rem;
    left: 0;
    right: 0;
    margin: auto;
}
.befor{
   width: 1.875rem;
    height: 1.25rem;
    background: #ff7373;
    color: #fff;
    font-size: 0.75rem;
    border-radius: 0.3125rem;
    text-align: center;
    line-height: 1.25rem;
    margin-right: 0.3125rem;
}
.counterpart{
   width: 1.875rem;
    height: 1.25rem;
    background: #22d8d9;
    color: #fff;
    font-size: 0.75rem;
    border-radius: 0.3125rem;
    text-align: center;
    line-height: 1.25rem;
    margin-right: 0.3125rem;
    margin-left: 20px;
}
</style>